import * as yup from "yup";

const AdditionalInfoSchema = yup.object().shape({
    veteran: yup
        .string()
        .nullable()
        .transform((v) => (v === "" ? null : v)),
    ethnicity: yup
        .string()
        .nullable()
        .transform((v) => (v === "" ? null : v)),
    race: yup
        .string()
        .nullable()
        .transform((v) => (v === "" ? null : v)),
    country: yup
        .string()
        .nullable()
        .transform((v) => (v === "" ? null : v)),
    phoneNumber: yup
        .string()
        .nullable()
        .transform((v) => (v === "" ? null : v))
        .matches(/^\+?\d{7,15}$/, "Invalid phone number"),
});

export default AdditionalInfoSchema;
